import React, {useState,useEffect} from 'react';
import {Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
//import useReactRouter from 'use-react-router';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
//import useStyles from './Styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
//import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
//import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
//import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
//import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import {Inc,Page,Item,Owner,PageNameLengthMax,PageNameLengthMin,PageGuideLengthMax} from './Inc';
import Ajax from './Ajax';
//import ColInput from './ColInput';
import InputString from './InputString';
import RowData from './RowData';
import DropImage from './DropImage';
import Loading from './Loading';
import Yesno from './Yesno';
import Toast from './Toast';
import {Tools} from './Tools';

interface PageInputProps {
    owner:Owner,
	managerId:number,
	pageId:number,
	isOpen:boolean,
	close(updated:boolean,pageId:number):void,
}

//interface RCProps extends RouteComponentProps<{id:string}> {
	
//}

//let pageId = 0;
//let errors:string[] = [];
let pageImgs:{ [key: string]: string; } = {};
//let items:Cardset[] = [];
let pageItemIds:number[] = [];

const PageInput = (props:PageInputProps)=> {
    Ajax.setEditorId(props.owner.owner_id);

    //const rcp:RCProps = useReactRouter();
    //const classes = useStyles();

	const defItems:Item[] = [];
	const defStates = {
        page: Inc.defaultPage(),
        photo_ids: [],
        items: defItems,
        yesno: "",
		errors: [] as string[],
		hasError: false,
        notFound: false,
        isLoading: true,
    };
    const [states,setStates] = useState(defStates);
	const [toast,setToast] = useState('');

    const load = ()=>{
		pageImgs = {};
		pageItemIds = [];
        Ajax.send("page/get",{page_id:props.pageId},(res:any)=>{
            //console.log(res);
            if( res.ok ){
				let hasError = false;
				let errors = [] as string[];
				if( !res.page.page_name || res.page.page_name==='' ){
					hasError = true;
					errors = ['page_name'];
				}

				setStates({page:Inc.convPage(res.page),items:res.param.items,photo_ids:res.param.photo_ids,errors:errors,yesno:"",hasError:hasError,notFound:false,isLoading:false});
            } else {
                setStates({...states,notFound:true});
            }
        });
    }

    //const change = (name:keyof Page,value:string)=>{
    //    setStates({...states,"page":{...states.page,[name]:value}});
    //}

	const onChangeString = (name:keyof Page) => (value: string,hasError: boolean) => {
		//const item = {...states.item,[name]:value};
		validatePage({...states.page,[name]:value},name,hasError);
	};

	const validatePage = (page:Page,name:string,hasError:boolean)=>{
		let errors = [...states.errors];
		const index = errors.indexOf(name);
		if( index>=0 ){
			if(!hasError){
				errors.splice(index, 1);
			}
		} else {
			if(hasError){
				errors.push(name);
			}
		}
		setStates({...states,page:page,errors:errors,hasError:errors.length>0});
	}

    const changeImage = (id:string,src:string)=>{
        pageImgs[ id ] = src;
    }

    const yes = ()=>{
        let page_id = 0;
        if( states.page.page_id && states.page.page_id>0 ){
            page_id = states.page.page_id;
        }
        setStates({...states,yesno:'',isLoading:true});
        Ajax.send("page/do",{page_id:page_id,manager_id:props.managerId,page:states.page,imgs:pageImgs,item_ids:pageItemIds},(res:any)=>{
            //console.log(res);
            if( res.ok ){
                //setStates({...states,yesno:'',isLoading:false});
				setStates(defStates);
				props.close(true,res.page_id);
            } else {
                setStates({...states,yesno:"",isLoading:false});
				setToast("登録できませんでした");
            }
        },(err:any)=>{
            setStates({...states,yesno:"",isLoading:false});
			setToast("登録できませんでした");
        });
    }
    const no = ()=>{
        setStates({...states,yesno:""});
    }
    const closeToast = ()=>{
		setToast("");
    }
    const reorder = (list:Item[], startIndex:number, endIndex:number) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const grid = 8;

    const getItemStyle = (isDragging:boolean, draggableStyle:any) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: "none",
        padding: grid * 2,
        margin: `0 0 ${grid}px 0`,

        // change background colour if dragging
        background: isDragging ? "lightgreen" : "white",
        border: `1px solid #CCCCCC`,

        // styles we need to apply on draggables
        ...draggableStyle
    });

    const getListStyle = (isDraggingOver:boolean) => ({
        background: isDraggingOver ? "#EEEEFF" : "#EEEEEE",
        padding: 0,
        width: "100%"
    });

    const onDragEnd = (result:any)=>{
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const items = reorder(
            states.items,
            result.source.index,
            result.destination.index
        );

        pageItemIds = new Array<number>(items.length).fill(0);
        
        for( let i=0 ; i<items.length ; i++ ){
            pageItemIds[i] = items[i].item_id;
        }
        setStates({...states,items:items});
    }
	const close = ()=>{
		setStates(defStates);
		props.close(false,0);
	}
    const confirm = ()=>{
        //console.log("states",states);
        //console.log("newImgs",newImgs);
        //console.log("errors",errors);
		if( states.hasError ){
			
		} else {
        	setStates({...states,yesno:"この内容で登録します。\nよろしいですか？"});
		}
    }

    useEffect( ()=>{
		if(!props.isOpen){
			return;
		}
        load();
		window.scrollTo(0,0);
    },[props.isOpen]);

    if( states.notFound ){
        return (
            <Redirect to="/"/>
        );
    }

    let photo_ids:number[] = [];
    for( let i=0 ; i<10 ; i++ ){
        if( states.photo_ids[i] ){
            photo_ids.push( states.photo_ids[i] );
        } else {
            photo_ids.push(0);
        }
    }

	if( !props.isOpen ){
		return null;
	}

    if( states.isLoading ){
        return (
            <Loading isLoading={true}/>
        );
    }

    let page_id = "未定";
    if( states.page.page_id>0 ){
        page_id = String(states.page.page_id);
    }

    //let toCancel = "/page";
    //if( states.page.page_id>0 ){
    //    toCancel = "/page/"+String(states.page.page_id);
    //}

    //let error = false;
    //if( states.page.page_name==="" ){
    //    error = true;
    //}


	return (
		<Dialog
			fullScreen
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
		>
			<DialogContent style={{padding:"0",margin:"0",backgroundColor:'#F5F5F5'}}>

				<AppBar position="fixed" style={{backgroundColor:`#FFFFFF`}}>
					<Toolbar variant="dense" style={{backgroundColor:`#FFFFFF`}}>
						<div style={{color:'#333333',flex:'1'}}><ShoppingCartIcon style={{verticalAlign:'middle',marginRight:'0.25em'}}/><span style={{verticalAlign:'middle'}}>シリーズ編集</span></div>
						<Button variant="text" color="primary" onClick={close} style={{marginRight:`0.5em`}}>もどる</Button>
						<Button variant="contained" color="primary" disabled={states.hasError} onClick={confirm}>登録</Button>
					</Toolbar>
				</AppBar>

				<div style={{maxWidth:'1280px',width:'100%',boxSizing:'border-box',padding:"4em 1em",margin:'0 auto',backgroundColor:'#FFFFFF'}}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">シリーズ名<span className="formRequired">必須</span></Typography>
							<div className="formExplanation">
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<InputString label="シリーズ名" required={true} value={states.page.page_name} onChange={onChangeString("page_name")} helper={PageNameLengthMin+'文字以上'+PageNameLengthMax+'文字以内'} opt={{minLength:PageNameLengthMin,maxLength:PageNameLengthMax}}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>

						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">シリーズ画像</Typography>
							<div className="formExplanation">
								シリーズ名のすぐ後に表示される画像（最初の画像）です。<br/>
								<b>幅1280pxの画像</b>を用意するとキレイに表示されます。<br/>
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<div style={{textAlign:"center",marginBottom:"1em"}}>
                                <DropImage owner_id={props.owner.owner_id} data={pageImgs["img"]} img_id={states.page.img_id} id="img" change={changeImage}/>
							</div>
							<div className="formHelper">
							1280pxより大きい場合は自動的に縮小されます（PNG / JPEG / GIF）<br/>
							</div>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>

						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">シリーズの紹介文</Typography>
							<div className="formExplanation">
								シリーズの内容やこのシリーズに含まれる商品の説明をなるべくわかりやすく書いてください
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<InputString label="シリーズの紹介文" required={false} value={states.page.page_guide} onChange={onChangeString("page_guide")} helper={Tools.comma(PageGuideLengthMax)+'文字以内'} opt={{rows:10,maxLength:PageGuideLengthMax}}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>

						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">追加画像</Typography>
							<div className="formExplanation">
								シリーズの紹介文の後に表示される画像です。<br/>
								<b>幅1280pxの画像</b>を用意するとキレイに表示されます。<br/>
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<Grid container spacing={2}>
								{photo_ids.map((img_id:number,index:number)=>{
									const key = "photo"+String(index+1);
									const name = "追加画像" + String(index+1);
									return (
										<Grid item key={key} sm={6} md={4}>
											<DropImage owner_id={props.owner.owner_id} data={pageImgs[key]} img_id={img_id} name={name} id={key} change={changeImage}/>
										</Grid>
									);
								})}
							</Grid>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>


						<Grid item xs={12} sm={3} md={4}>
							<Typography variant="h6">商品の並び</Typography>
							<div className="formExplanation">
								同じシリーズの商品が一覧表示される場合の順番を設定できます
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<FormControl fullWidth={true}>
								<DragDropContext onDragEnd={onDragEnd}>
									<Droppable droppableId="droppable">
										{(provided, snapshot) => (
											<div
												{...provided.droppableProps}
												ref={provided.innerRef}
												style={getListStyle(snapshot.isDraggingOver)}
											>
												{states.items.map((item, index) => {
													const key = "item"+index;
													return (
														<Draggable key={key} draggableId={key} index={index}>
															{(provided, snapshot) => (
																<div
																	ref={provided.innerRef}
																	{...provided.draggableProps}
																	{...provided.dragHandleProps}
																	style={getItemStyle(
																		snapshot.isDragging,
																		provided.draggableProps.style
																	)}
																>
																	<div>
																		{item.item_name}<br/>
																		<span style={{color:"gray"}}>ID:{item.item_id}</span>
																	</div>
																</div>
															)}
														</Draggable>
													)}
												)}
												{provided.placeholder}
											</div>
										)}
									</Droppable>
								</DragDropContext>

								{states.items.length===0 ? (
									<div style={{padding:"0",marginBottom:"1em"}}>このシリーズの商品はありません</div>
								):(
									<FormHelperText>※ドラッグ＆ドロップで順序を変更できます</FormHelperText>
								)}

							</FormControl>

						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>

					</Grid>
					<div style={{maxWidth:'300px',marginLeft:'auto',marginTop:'2em',backgroundColor:'#F0F0F0',padding:'1em',boxSizing:'border-box'}}>
						<RowData name="シリーズID" value={page_id} height={true}/>
						<RowData name="商品数" value={String(states.page.num_item)} height={true}/>
						<RowData name="状態" value={states.page.status_label} height={true}/>
					</div>
				</div>
			</DialogContent>
            <Yesno mes={states.yesno} yes={yes} no={no} isOpen={states.yesno!==""}/>
            <Toast mes={toast} close={closeToast}/>
		</Dialog>
	);
}

export default PageInput;
